import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import BaseConfiguration from 'modules/funnels/funnel/components/step-configuration-tab/base-configuration-tab/components/base-configuration';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import { useBaseFunnelStepConfigurationSettings } from 'modules/funnels/funnel/hooks/use-base-funnel-step-configuration-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useUpdateBaseConfigurationTab } from 'modules/funnels/funnel/hooks/use-update-base-configuration-tab';
import { BaseFunnelStepConfigurationEditInterface, BaseFunnelStepConfigurationInterface } from 'modules/funnels/funnel/types/base-funnel-step-configuration-settings-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
interface BaseConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function BaseConfigurationTab(t0) {
  const $ = _c(16);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    funnelStepConfigurationSettings,
    mutateFunnelStepConfigurationSettings
  } = useBaseFunnelStepConfigurationSettings(funnelStep.id);
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const t1 = `${FUNNELS_API}/steps/${funnelStep.id}`;
  let t2;
  if ($[0] !== funnelId || $[1] !== funnelStep.id || $[2] !== t1) {
    t2 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t1
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    updateFetcher
  } = useUpdateBaseConfigurationTab(t2);
  let t3;
  if ($[4] !== funnelStep.id || $[5] !== mutateFunnelStepConfigurationSettings || $[6] !== mutateFunnelStepsList || $[7] !== updateFetcher) {
    t3 = async baseData => {
      ;
      try {
        await updateFetcher(baseData, async () => {
          await mutateFunnelStepConfigurationSettings(data => {
            if (data) {
              return {
                ...data,
                name: baseData.name,
                page: {
                  ...data.page,
                  path: baseData.page.path
                }
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: baseData.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t4) {
        const e = t4;
        throw e;
      }
    };
    $[4] = funnelStep.id;
    $[5] = mutateFunnelStepConfigurationSettings;
    $[6] = mutateFunnelStepsList;
    $[7] = updateFetcher;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleSave = t3;
  if (!funnelStepConfigurationSettings || !funnel || !funnelStep.page) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <TabContentLoader />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  const t4 = funnel?.domain.domainName;
  let t5;
  if ($[10] !== funnelStep.inRunningSplitTest || $[11] !== funnelStepConfigurationSettings.name || $[12] !== funnelStepConfigurationSettings.page.path || $[13] !== handleSave || $[14] !== t4) {
    t5 = <BaseConfiguration onSave={handleSave} domainName={t4} name={funnelStepConfigurationSettings.name} path={funnelStepConfigurationSettings.page.path} pathDisabled={funnelStep.inRunningSplitTest} />;
    $[10] = funnelStep.inRunningSplitTest;
    $[11] = funnelStepConfigurationSettings.name;
    $[12] = funnelStepConfigurationSettings.page.path;
    $[13] = handleSave;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export default BaseConfigurationTab;